import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Package, FileText, Receipt, LogOut, ShieldCheck} from 'lucide-react';
import ThemaSchalter from './ThemaSchalter';
import { useAuth } from '../contexts/AuthContext';
import TwoFactorModal from './TwoFactorModal';

const NAV = [
  { to: '/', label: 'Produkte', icon: Package, end: true },
  { to: '/contracts', label: 'Meine Verträge', icon: FileText },
  { to: '/orders', label: 'Bestellungen', icon: Receipt },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const [showTwoFactor, setShowTwoFactor] = useState(false);

  return (
    <div className="min-h-full flex flex-col">
      <header className="bg-surface border-b border-slate-200">
        <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between">
          <img src="/juni-logo.svg" alt="juni" className="h-7" />
          <div className="flex items-center gap-4">
            <div className="text-right hidden sm:block">
              <p className="text-sm font-medium text-slate-900 leading-tight">{user?.name}</p>
              <p className="text-xs text-slate-500 leading-tight">{user?.customer?.companyName}</p>
            </div>
            <ThemaSchalter />
            <button
              onClick={() => setShowTwoFactor(true)}
              title="Zwei-Faktor-Authentifizierung"
              className="text-slate-400 hover:text-slate-700 p-2"
            >
              <ShieldCheck size={18} />
            </button>
            <button
              onClick={logout}
              title="Abmelden"
              className="text-slate-400 hover:text-slate-700 p-2"
            >
              <LogOut size={18} />
            </button>
          </div>
        </div>
        <nav className="max-w-5xl mx-auto px-4 flex gap-1">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `inline-flex items-center gap-1.5 px-3 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                  isActive
                    ? 'border-brand-600 text-brand-600'
                    : 'border-transparent text-slate-500 hover:text-slate-700'
                }`
              }
            >
              <Icon size={15} /> {label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="flex-1 max-w-5xl w-full mx-auto px-4 py-6">
        <Outlet />
      </main>

      {showTwoFactor && <TwoFactorModal onClose={() => setShowTwoFactor(false)} />}
    </div>
  );
}
